// ui/welcomeModal.js
// Welcome modal for new players

import logger from '../utils/logger.js';

let modalElement = null;

/**
 * Create the welcome modal HTML
 */
function createModalHTML() {
    return `
        <div class="modal-overlay" id="welcome-modal-overlay">
            <div class="modal-content welcome-modal">
                <div class="modal-header">
                    <h2>Welcome to IdleRealms</h2>
                </div>
                <div class="modal-body">
                    <p class="welcome-intro">
                        An idle adventure awaits! Train skills, gather resources, and grow stronger - even while away.
                    </p>

                    <div class="welcome-section">
                        <h3>Getting Started</h3>
                        <ul class="welcome-list">
                            <li><span class="welcome-icon">🎯</span> Click any skill in the sidebar to begin training</li>
                            <li><span class="welcome-icon mining-icon"></span> Start with <strong>Mining</strong> or <strong>Woodcutting</strong> to gather resources</li>
                            <li><span class="welcome-icon">🔨</span> Process materials with <strong>Smithing</strong> and <strong>Woodworking</strong></li>
                            <li><span class="welcome-icon">🔗</span> Many skills interact - explore and discover synergies!</li>
                        </ul>
                    </div>

                    <div class="welcome-section">
                        <h3>Key Features</h3>
                        <ul class="welcome-list">
                            <li><span class="welcome-icon">🛠️</span> <strong>Tools</strong> - Buy better tools with gold to work faster</li>
                            <li><span class="welcome-icon">📦</span> <strong>Inventory & Bank</strong> - Bank items stack infinitely</li>
                            <li><span class="welcome-icon">🔓</span> <strong>Unlocks</strong> - New content unlocks as you level up</li>
                            <li><span class="welcome-icon">⚔️</span> <strong>Combat</strong> - Fight monsters for loot and XP</li>
                            <li><span class="welcome-icon">🏪</span> <strong>Shop</strong> - Cheap starter gear and free daily supplies!</li>
                        </ul>
                    </div>

                    <div class="welcome-section welcome-highlight">
                        <h3>Offline Progress</h3>
                        <p class="welcome-offline-text">
                            Your character continues working while you're away. Close the game and come back to claim up to <strong>24 hours</strong> of progress!
                        </p>
                    </div>

                    <div class="welcome-tip">
                        <span class="welcome-icon">💡</span>
                        <span>Look for <strong>(!)</strong> icons for extra info. Check the <strong>Glossary</strong> for detailed explanations!</span>
                    </div>

                    <div class="welcome-actions">
                        <button class="welcome-btn primary" onclick="window.welcomeModal.close()">
                            Begin Your Adventure
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `;
}

/**
 * Show the welcome modal for new players
 */
export function showWelcomeModal() {
    closeWelcomeModal();

    const modalContainer = document.createElement('div');
    modalContainer.innerHTML = createModalHTML();
    modalElement = modalContainer.firstElementChild;
    document.body.appendChild(modalElement);

    document.addEventListener('keydown', handleEscapeKey);

    logger.debug('[WELCOME] Modal shown for new player');
}

/**
 * Close the welcome modal
 */
export function closeWelcomeModal() {
    if (modalElement) {
        modalElement.remove();
        modalElement = null;
        document.removeEventListener('keydown', handleEscapeKey);
        logger.debug('[WELCOME] Modal closed');
    }
}

/**
 * Handle Escape key
 */
function handleEscapeKey(e) {
    if (e.key === 'Escape') {
        closeWelcomeModal();
    }
}

// Expose to window for onclick handlers
window.welcomeModal = {
    show: showWelcomeModal,
    close: closeWelcomeModal
};

export default {
    showWelcomeModal,
    closeWelcomeModal
};
